import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { FileText, RefreshCw, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const BriefPage = ({ toast }) => {
  const [brief, setBrief] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${BACKEND_URL}/api/brief`);
      setBrief(r.data);
    } catch (e) {
      toast({ title: 'Error cargando Brief', variant: 'destructive' });
    }
    setLoading(false);
  };

  if (loading) {
    return <div className="flex justify-center p-12"><Loader2 className="animate-spin" /></div>;
  }

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2">
              <FileText className="h-5 w-5" /> Brief de Empresa
            </CardTitle>
            <CardDescription>
              Memoria viva del negocio. Generado y actualizado por el Coordinador.
              {brief?.updated_at && ` · Última actualización: ${new Date(brief.updated_at).toLocaleString('es-ES')}`}
              {brief?.version && ` · Versión ${brief.version}`}
            </CardDescription>
          </div>
          <Button variant="outline" size="sm" onClick={load}>
            <RefreshCw className="h-4 w-4 mr-1" /> Recargar
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {brief?.content ? (
          <pre className="whitespace-pre-wrap text-sm font-sans leading-relaxed bg-slate-50 p-6 rounded-lg border">
            {brief.content}
          </pre>
        ) : (
          <div className="text-center py-16 text-slate-400">
            <FileText className="h-12 w-12 mx-auto mb-3 opacity-30" />
            <p className="font-medium">El Brief todavía no existe.</p>
            <p className="text-sm mt-1">
              Rellena "Mi Negocio" y ejecuta la Auditoría 360. El Coordinador generará el Brief automáticamente.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default BriefPage;
